const ManuallyInputtedTransactionRefStatus = require('@/lib/Payments/ManuallyInputtedTransactionRefStatus');
const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');
const { populate } = require('@/functions/objects');
const { toBool, toInt, toNullableInt, toString } = require('../../functions/transform');

/**
 * @param {object} [data]
 *
 * @constructor
 */
const PaymentMethod = function (data = {}) {
    this.driverRef = '';
    this.ID = null;
    this.ref = null;
    this.name = '';
    this.displayName = '';
    this.navOrder = 0;
    this.shortName = '';
    this.showOnEpos = false;
    this.supportsCashback = false;
    this.supportsGratuity = false;

    /**
     * The ability to make a -ve payment or credit in ProPoint.
     * Note: this is not the same as a refund, although it often referred to as a refund.
     * Not all integrated payment methods support -ve payments.
     *
     * @type {boolean}
     */
    this.supportsNegativePaymentInProPoint = false;

    /**
     * A Partial Refund is a refund against an existing payment that was taken online e.g. SagePay Server.
     * The refund is attempted from app rather than from ProPoint.
     * This property does not apply to any paymentmethod where supportsEpos = true
     *
     * @type {boolean}
     */
    this.supportsPartialRefunds = false;

    /**
     * A refund against and existing payment made by an integrated terminal in ProPoint as opposed to on the server.
     * Example methods: Clover, Payyo.
     *
     * @type {boolean}
     */
    this.supportsIntegratedRefundsInProPoint = false;

    this.supportsSubscriptions = false;
    this.manuallyInputtedTransactionRefStatus = null;

    // Additional fields for CompanyPaymentMethod (via companies endpoint).
    this.companiesPaymentMethodsID = null;
    this.config = '';

    this.disabled = false;

    populate(this, data);
};

PaymentMethod.prototype = {
    getHydrationMap() {
        return {
            companiesPaymentMethodsID: toNullableInt,
            config: {},
            displayName: toString,
            driverRef: toString,
            ID: {
                field: ['ID', 'paymentMethodID'],
                transform: toInt,
            },
            manuallyInputtedTransactionRefStatus: toString,
            name: toString,
            navOrder: toInt,
            ref: toString,
            shortName: toString,
            showOnEpos: toBool,
            supportsCashback: toBool,
            supportsGratuity: toBool,
            supportsIntegratedRefundsInProPoint: toBool,
            supportsNegativePaymentInProPoint: toBool,
            supportsPartialRefunds: toBool,
            supportsSubscriptions: toBool,
        };
    },

    get supportsChange() {
        return [
            PaymentMethodRef.CASH,
            PaymentMethodRef.FLEXI_VOUCHER,
        ].includes(this.ref);
    },

    supportsManualTransactionRef() {
        return [
            ManuallyInputtedTransactionRefStatus.REQUIRED,
            ManuallyInputtedTransactionRefStatus.OPTIONAL,
        ].includes(this.manuallyInputtedTransactionRefStatus);
    },

    /**
     * Returns the JSON-parsed config object.
     * If there is no config, returns an empty object.
     *
     * @returns {object}
     */
    getConfig() {
        if (!this.config) {
            return {};
        }

        return JSON.parse(this.config);
    },

    /**
     * @param {object} config
     */
    setConfig(config) {
        this.config = JSON.stringify(config);
    },
};

module.exports = PaymentMethod;
